<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>Asset Users</mat-card-title>
    <button mat-fab [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
      [disabled]="!isAdminGroupUser" (click)="AddAssetUser()" color="accent"
      style="position:absolute; right:15px;top:8px;width:35px; height:35px;" matTooltip="Add Asset User">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">add</i>
      </span>
    </button>
    <button mat-fab (click)="exportRecords()" color="accent"
      style="position:absolute; right:55px;top:8px;width:35px; height:35px;" *ngIf="assetUsers != null && assetUsers.length >0"
      matTooltip="Download Records">
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size:30px;">download</i>
      </span>
    </button>
     
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
       <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <app-search-input [label]="'Search by EmployeeId or Email'"
                            [placeholder]="'Search by EmployeeId or Email'"
                             [tooltip]="'Enter Employee ID or Email and press Enter to search.'"
                            (search)="applySearch($event)" (cleared)="onClearSearch()">
                        </app-search-input>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
         <app-filter-input *ngIf="assetUsers!=null && assetUsers.length >0" (filterChanged)="applyFilter($event)"></app-filter-input>
      </div>
    </div>
      <div class="table-responsive" style="width:99%;">
     <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
          (matSortChange)="announceSortChange($event)" *ngIf="dataSource.data.length > 0"
            aria-label="Table listing users assigned to the asset">

          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef>S No. </th>
            <td mat-cell *matCellDef="let element; let i = index;"> {{(i+1)+(pageEvent.pageSize*pageEvent.pageIndex)}}
            </td>
          </ng-container>
          <!-- assetUserId Column not visible -->
          <ng-container matColumnDef="assetUserId">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"> {{element.assetUserId}} </td>
          </ng-container>

          <!-- employeeId Column -->
          <ng-container matColumnDef="employeeId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by employeeId">EmployeeId
            </th>
            <td mat-cell *matCellDef="let element"> {{element.employeeId}} </td>
          </ng-container>
          <!-- firstName Column -->
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by firstName">First Name
            </th>
            <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
          </ng-container>
          <!-- lastName Column -->
          <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by lastName">Last Name
            </th>
            <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
          </ng-container>

          <!-- email Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by email">Email</th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
          </ng-container>

          <!-- mobileNumber Column -->
          <ng-container matColumnDef="mobileNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by mobileNumber">Mobile</th>
            <td mat-cell *matCellDef="let element"> {{element.mobileNumber}} </td>
          </ng-container>

          <!-- userStatus Column -->
          <ng-container matColumnDef="userStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by userStatus">Staus</th>
            <td mat-cell *matCellDef="let element">{{element.userStatus}}</td>
          </ng-container>
          <!-- isDeleted -->
          <ng-container matColumnDef="isDeleted">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header
              sortActionDescription="Sort by orgWarehouseName">Is Deleted
            </th>
            <td mat-cell *matCellDef="let element"> {{element.isDeleted}} </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef>Edit</th>
            <td mat-cell *matCellDef="let element">
              <button mat-mini-fab aria-label="Edit" (click)="editAssetUserDetail($event, element)"
                [disabled]="!isAdminGroupUser || (element.isDeleted)">
                <mat-icon matTooltip="Edit Inventory">edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>Delete</th>
            <td mat-cell *matCellDef="let element">
              <button mat-mini-fab aria-label="Delete" (click)="softDelete($event, element)" color="warn"
                [disabled]="!isAdminGroupUser || (element.isDeleted)">
                <mat-icon matTooltip="Delete Asset user">delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
         <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
        </mat-paginator>
      <div *ngIf="isLoaderResult" class="custSpinner">
      </div>
    </mat-card-content>
  </mat-card>
</div>
